import {
  Container,
  Paper,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText
} from '@mui/material'
import React from 'react'
import WarningIcon from '@mui/icons-material/Warning'
import { useStyles } from '../styles'

interface PickingNoRouteProps {
  handleStartPicking: any
}

export const PickingNoRoute: React.FC<PickingNoRouteProps> = ({
  handleStartPicking
}) => {
  const classes = useStyles()
  return (
    <Container maxWidth='xl'>
      <Paper elevation={1} style={{ padding: '15px' }}>
        <List className={classes.alert}>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <WarningIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='No tiene asignada ruta de picking'
              secondary=''
            />
          </ListItem>
        </List>

        <Button
          variant='contained'
          color='primary'
          onClick={handleStartPicking}
        >
          Aceptar
        </Button>
      </Paper>
    </Container>
  )
}
